// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' \u0024fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Int64: { input: number; output: number; }
};

/**
 * Adds an extra camera to a PENDING recording: the next stream, video only, and
 * its first batch of tickets (sequences 0..119), reserved as startRecording
 * reserves.
 */
export type AddStreamInput = {
  recordingId: Scalars['Int64']['input'];
};

export type AddStreamOrErrorPayload = AddStreamPayload | ErrorPayload | QuotaExceededPayload;

export type AddStreamPayload = {
  __typename?: 'AddStreamPayload';
  stream: Stream;
  tickets: Array<UploadTicket>;
};

/**
 * How a segment was captured: one MediaRecorder run on one camera in one
 * orientation. Bound onto the segment row itself.
 */
export type Capture = {
  __typename?: 'Capture';
  audioDeviceId: Scalars['String']['output'];
  facingMode: Scalars['String']['output'];
  height: Scalars['Int64']['output'];
  mime: Scalars['String']['output'];
  orientation: Orientation;
  videoDeviceId: Scalars['String']['output'];
  width: Scalars['Int64']['output'];
};

export type CaptureInput = {
  audioDeviceId: Scalars['String']['input'];
  facingMode: Scalars['String']['input'];
  height: Scalars['Int64']['input'];
  mime: Scalars['String']['input'];
  orientation: Orientation;
  videoDeviceId: Scalars['String']['input'];
  width: Scalars['Int64']['input'];
};

/**
 * Every part with the ETag its PUT answered. Completes the multipart upload and
 * enqueues assembly, as finishRecording does.
 */
export type CompleteFileUploadInput = {
  parts: Array<CompletedPartInput>;
  recordingId: Scalars['Int64']['input'];
};

export type CompleteFileUploadOrErrorPayload = CompleteFileUploadPayload | ErrorPayload;

export type CompleteFileUploadPayload = {
  __typename?: 'CompleteFileUploadPayload';
  recording: Recording;
};

export type CompletedPartInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type ErrorPayload = {
  __typename?: 'ErrorPayload';
  byFields: Array<FieldMessage>;
  message: Scalars['String']['output'];
};

export type FieldMessage = {
  __typename?: 'FieldMessage';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * The manifest: every stream of the recording, by index from 0, each with at
 * least one part. The first manifest for a recording wins, and a retry must
 * repeat it exactly. The answer comes before assembly: the recording is
 * ASSEMBLING and the assemble-recording job moves it on.
 */
export type FinishRecordingInput = {
  recordingId: Scalars['Int64']['input'];
  streams: Array<StreamManifestInput>;
};

export type FinishRecordingOrErrorPayload = ErrorPayload | FinishRecordingPayload;

export type FinishRecordingPayload = {
  __typename?: 'FinishRecordingPayload';
  recording: Recording;
};

export type FormField = {
  __typename?: 'FormField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Me = {
  __typename?: 'Me';
  createdAt: Timestamp;
  displayName: Scalars['String']['output'];
  id: Scalars['Int64']['output'];
  limitBytes: Scalars['Int64']['output'];
  reservedBytes: Scalars['Int64']['output'];
  usedBytes: Scalars['Int64']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addStream: AddStreamOrErrorPayload;
  completeFileUpload: CompleteFileUploadOrErrorPayload;
  finishRecording: FinishRecordingOrErrorPayload;
  requestUploadPartURLs: RequestUploadPartURLsOrErrorPayload;
  requestUploadURLs: RequestUploadURLsOrErrorPayload;
  signOut: SignOutPayload;
  startFileUpload: StartFileUploadOrErrorPayload;
  startRecording: StartRecordingOrErrorPayload;
};


export type MutationaddStreamArgs = {
  input: AddStreamInput;
};


export type MutationcompleteFileUploadArgs = {
  input: CompleteFileUploadInput;
};


export type MutationfinishRecordingArgs = {
  input: FinishRecordingInput;
};


export type MutationrequestUploadPartURLsArgs = {
  input: RequestUploadPartURLsInput;
};


export type MutationrequestUploadURLsArgs = {
  input: RequestUploadURLsInput;
};


export type MutationstartFileUploadArgs = {
  input: StartFileUploadInput;
};

export enum Orientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
  SQUARE = 'SQUARE'
}

export type PartInput = {
  bytes: Scalars['Int64']['input'];
  capture: CaptureInput;
  endMs: Scalars['Int64']['input'];
  segment: Scalars['Int']['input'];
  sequence: Scalars['Int']['input'];
  sha256: Scalars['String']['input'];
  startMs: Scalars['Int64']['input'];
};

export type Query = {
  __typename?: 'Query';
  me: Me;
  recording?: Maybe<Recording>;
  recordings: RecordingsConnection;
  /**
   * The bot's t.me link. Telegram lets the bot write to a user only after they
   * press Start there, so the "recording saved" notice depends on it.
   */
  telegramBotURL: Scalars['String']['output'];
};


export type QueryrecordingArgs = {
  id: Scalars['Int64']['input'];
};

/**
 * The user's bytes in the bucket plus what outstanding upload URLs could still
 * add would pass limitBytes. Nothing was issued.
 */
export type QuotaExceededPayload = {
  __typename?: 'QuotaExceededPayload';
  limitBytes: Scalars['Int64']['output'];
  message: Scalars['String']['output'];
  reservedBytes: Scalars['Int64']['output'];
  usedBytes: Scalars['Int64']['output'];
};

export type Recording = {
  __typename?: 'Recording';
  bytes: Scalars['Int64']['output'];
  createdAt: Timestamp;
  error: Scalars['String']['output'];
  finishedAt?: Maybe<Timestamp>;
  id: Scalars['Int64']['output'];
  kind: RecordingKind;
  /** Every segment of every stream, by stream and then by index. */
  segments: SegmentsConnection;
  status: RecordingStatus;
  streams: StreamsConnection;
};

/**
 * `record` is captured in the browser, part by part; `upload` is a finished file
 * sent as one S3 multipart upload.
 */
export enum RecordingKind {
  RECORD = 'RECORD',
  UPLOAD = 'UPLOAD'
}

/**
 * PENDING accepts uploads. finishRecording or completeFileUpload moves it to
 * ASSEMBLING and enqueues the assemble-recording job, which ends in READY or
 * FAILED (with `error` set).
 */
export enum RecordingStatus {
  ASSEMBLING = 'ASSEMBLING',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READY = 'READY'
}

export type RecordingsConnection = {
  __typename?: 'RecordingsConnection';
  nodes: Array<Recording>;
  totalCount: Scalars['Int64']['output'];
};

/**
 * Presigned PUT URLs for the named parts, numbered from 1 as S3 numbers them.
 * Ask again for a part whose upload failed; only that part is re-sent.
 */
export type RequestUploadPartURLsInput = {
  partNumbers: Array<Scalars['Int']['input']>;
  recordingId: Scalars['Int64']['input'];
};

export type RequestUploadPartURLsOrErrorPayload = ErrorPayload | RequestUploadPartURLsPayload;

export type RequestUploadPartURLsPayload = {
  __typename?: 'RequestUploadPartURLsPayload';
  parts: Array<UploadPartURL>;
};

/**
 * The next batch of up to 120 tickets of one stream, starting at sequence
 * `from`. Asking again for sequences already issued re-signs them without
 * reserving twice.
 */
export type RequestUploadURLsInput = {
  from: Scalars['Int']['input'];
  recordingId: Scalars['Int64']['input'];
  stream: Scalars['Int']['input'];
};

export type RequestUploadURLsOrErrorPayload = ErrorPayload | QuotaExceededPayload | RequestUploadURLsPayload;

export type RequestUploadURLsPayload = {
  __typename?: 'RequestUploadURLsPayload';
  tickets: Array<UploadTicket>;
};

/**
 * `downloadURL` is a presigned GET on the public origin, valid for two hours;
 * null with an error when presigning fails, so one segment cannot null the list.
 */
export type Segment = {
  __typename?: 'Segment';
  bytes: Scalars['Int64']['output'];
  capture: Capture;
  downloadURL?: Maybe<Scalars['String']['output']>;
  endMs: Scalars['Int64']['output'];
  index: Scalars['Int64']['output'];
  startMs: Scalars['Int64']['output'];
  stream: Scalars['Int64']['output'];
};

export type SegmentsConnection = {
  __typename?: 'SegmentsConnection';
  nodes: Array<Segment>;
  totalCount: Scalars['Int64']['output'];
};

export type SignOutPayload = {
  __typename?: 'SignOutPayload';
  redirectUrl: Scalars['String']['output'];
};

/**
 * Opens a PENDING recording of kind UPLOAD and an S3 multipart upload for a
 * finished file of `bytes` bytes, reserved against the user's limit. The file is
 * cut into `partCount` parts of `partBytes` each, the last one shorter.
 */
export type StartFileUploadInput = {
  bytes: Scalars['Int64']['input'];
  fileName: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type StartFileUploadOrErrorPayload = ErrorPayload | QuotaExceededPayload | StartFileUploadPayload;

export type StartFileUploadPayload = {
  __typename?: 'StartFileUploadPayload';
  partBytes: Scalars['Int64']['output'];
  partCount: Scalars['Int']['output'];
  recording: Recording;
};

export type StartRecordingOrErrorPayload = ErrorPayload | QuotaExceededPayload | StartRecordingPayload;

/**
 * Opens a PENDING recording of kind RECORD with its main stream 0 (camera and
 * microphone) and issues that stream's first batch of tickets (sequences
 * 0..119). Issuing reserves 8 MiB per ticket against the user's limit.
 */
export type StartRecordingPayload = {
  __typename?: 'StartRecordingPayload';
  recording: Recording;
  stream: Stream;
  tickets: Array<UploadTicket>;
};

/**
 * One video source of a recording, on the recording's timeline. Stream 0 is the
 * main camera with the microphone; the others are extra cameras, video only.
 * Each stream counts its own part sequences and segment indexes from 0.
 */
export type Stream = {
  __typename?: 'Stream';
  /**
   * The stream records the microphone: each of its segments needs an audio
   * track. A stream without it needs video only, and keeps any audio it carries.
   */
  hasAudio: Scalars['Boolean']['output'];
  index: Scalars['Int64']['output'];
  role: StreamRole;
  segments: SegmentsConnection;
};

/**
 * Every part the browser uploaded into one stream, in sequence order from 0.
 * Parts of one segment share `segment` and `capture`; segments are contiguous
 * from 0.
 */
export type StreamManifestInput = {
  index: Scalars['Int']['input'];
  parts: Array<PartInput>;
};

/**
 * MAIN is stream 0, the camera with the microphone; its segments need audio and
 * video. EXTRA is another camera beside it, video only.
 */
export enum StreamRole {
  EXTRA = 'EXTRA',
  MAIN = 'MAIN'
}

export type StreamsConnection = {
  __typename?: 'StreamsConnection';
  nodes: Array<Stream>;
  totalCount: Scalars['Int64']['output'];
};

export type Timestamp = {
  __typename?: 'Timestamp';
  formatted: Scalars['String']['output'];
  unix: Scalars['Int64']['output'];
};


export type TimestampformattedArgs = {
  layout?: Scalars['String']['input'];
};

export type UploadPartURL = {
  __typename?: 'UploadPartURL';
  expiresAt: Timestamp;
  partNumber: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/**
 * One presigned S3 POST for one part. Send multipart/form-data to `url` with
 * every entry of `fields` first, in order, and the part itself last as `file`.
 * The policy pins the object key and caps the body at 8 MiB, so a ticket is
 * good for exactly one part of at most that size, until `expiresAt`.
 */
export type UploadTicket = {
  __typename?: 'UploadTicket';
  expiresAt: Timestamp;
  fields: Array<FormField>;
  sequence: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};


}
